__webpack_require__.p = "/public/site/b2bideales/dist/";